module.exports = __webpack_public_path__ + "static/HTH2-24d26d7cc4f3f539cc6dee772d46a200.jpg";